import { Icon } from "@chakra-ui/react";
import { type ChainId, ChainIds } from "@umami/chains";
import { type FC, useMemo } from "react";

import { BitcoinLogo, BscLogo, EthereumLogo, EtherlinkLogo, TezSolidIcon } from "@/assets/icons";

type ChainIconProp = FC<{
  chainId: ChainId;
  boxSize?: string;
}>;
export const ChainIcon: ChainIconProp = ({ chainId, boxSize = "32px" }) => {
  const ChainIconSelector = useMemo(() => {
    //TODO: Refactor this to get the icon from the ChainRegistryClass in the future  (https://linear.app/tezos/issue/UMA-1708)
    switch (chainId) {
      case ChainIds.TEZOS:
        return TezSolidIcon;
      case ChainIds.ETHEREUM:
        return EthereumLogo;
      case ChainIds.ETHERLINK:
        return EtherlinkLogo;
      case ChainIds.BSC:
        return BscLogo;
      case ChainIds.BITCOIN:
        return BitcoinLogo;
      default:
        return undefined;
    }
  }, [chainId]);

  return <Icon as={ChainIconSelector} boxSize={boxSize} rounded="full" />;
};
